module.exports = __webpack_public_path__ + "static/media/award_white.e35b9c09.svg";